<template>
  <div class="page-main">
    <el-pagination
      background
      
      layout="prev, pager, next"
      :total="1000">
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'Page'
}
</script>
<style lang="scss">
.page-main {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: rgba(255, 79, 76, 1);
    border-color: rgba(255, 79, 76, 1);
  }
  .el-pager .number {
    border: 1px solid #DDDDDD;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    background: #fff;
    color: #666666;
    border-radius: 6px;
  }
}
</style>